<fa-icon *ngIf="column === selectedColumn"  [icon]="dir == 'desc' || dir === 'DESC' ? faLongArrowAltDown : faLongArrowAltUp" class="float-right"></fa-icon>
<fa-icon *ngIf="column !== selectedColumn" [icon]="faArrowsAltV" class="float-right text-muted"></fa-icon>
